import { render, staticRenderFns } from "./FilaAtendimento.vue?vue&type=template&id=446d7cf9&scoped=true&"
import script from "./FilaAtendimento.vue?vue&type=script&lang=js&"
export * from "./FilaAtendimento.vue?vue&type=script&lang=js&"
import style0 from "./FilaAtendimento.vue?vue&type=style&index=0&id=446d7cf9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446d7cf9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VContainer,VProgressCircular,VSkeletonLoader})
